<div class="bosysdetail-listimg">
    @for (item of images(); let k= $index; track $index) {
    <img [class.bosysdetail-img]="mediaService.deskmode()" (click)="openImageModal(k)" [class.bosysdetail-img-mobile]="!mediaService.deskmode()"
        loading="lazy" [src]="item" alt="image">
    }
</div>